import React, { useCallback } from "react";
import { PATHS } from "constants/pathConstants";
import { COLORS } from "components/v3/Theme/colors";
import Mixpanel from "utils/mixpanel";
import NotificationsIcon from "assets/images/Notifications.svg";
import WelcomeHero from ".";

type InactiveMembershipHeroProps = {};

const InactiveMembershipHero: React.FC<InactiveMembershipHeroProps> = () => {
  const onActionClick = useCallback(() => {
    Mixpanel.track(`To Do Card CTA Clicked - Inactive member`);
  }, [Mixpanel, PATHS]);

  return (
    <WelcomeHero
      headerIcon={NotificationsIcon}
      headerSubText={`
        You are unable to order a kit or report a cancer diagnosis to
        obtain oncology support. Please contact us at
        <a href='mailto:navigation@genomiclife.com' style='color: ${COLORS.ACCENT1_LIGHT}'>
          navigation@genomiclife.com
        </a>.
      `}
      headerText="Your Genomic Life membership is inactive"
      onActionClick={onActionClick}
      id="inactive-membership-card"
    />
  );
};

export default InactiveMembershipHero;
